import { IMAGES } from "../Images";
import "./Loader.css";

const Loader = () => {
  return (
    <div>
      <div className="loader" id="spinner">
        <img src="/logo.png" className="central-icon" alt="loader" />
      </div>
      {/* <div className="loader-content">Please wait while we load up things for you.</div>     */}
    </div>
  );
};

export default Loader;
